import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { officeApi } from "../../api/config";
import { Refund_Payment } from "../../api/projectapi";
import { ApprvCard, PaymentDetailInter } from "../../interface/interface";
import {
  ChargeChange,
  DetailReturnType,
  formatDate,
  makeComma,
  PaymnetDetailForm,
} from "../../lib/lib";
import { LoadingChange, ToastChange } from "../../reducers/config";
import "./css/index.css";
import { formatPaymentFailure } from "../../lib/paymentFailure";

type LocType = {
  state: ApprvCard;
};

function PaymentDetail() {
  const location = useLocation() as LocType;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState<PaymentDetailInter | undefined>(undefined);
  const [PaymentState, setPaymentState] =
    useState<DetailReturnType>("wait-state");
  const [chargeInfo, setChargeInfo] = useState({
    type: "",
    amt: 0,
    text: "",
  });
  const Refund = useCallback(() => {
    if (data) {
      dispatch(LoadingChange(true));
      const { prjt_id, rcrt_id, apply_id } = data;
      Refund_Payment(prjt_id, rcrt_id, apply_id).then(({ state, msg }) => {
        if (state) {
          dispatch(
            ToastChange({ active: true, content: "환불이 완료되었습니다" })
          );
          navigate(-1);
        } else {
          navigate(-1);
            dispatch(ToastChange({ active: true, content: formatPaymentFailure(msg) }));
        }
        dispatch(LoadingChange(false));
      });
    }
  }, [data, dispatch, navigate]);

  useEffect(() => {
    if (location.state) {
      officeApi
        .get(
          `/web/prjt/${location.state.prjt_id}/rcrt/${location.state.rcrt_id}/apply/${location.state.apply_id}`
        )
        .then(({ data: { sts_fg, succ_obj, err_msg } }) => {
          if (sts_fg) {
            setData(succ_obj);
            const rcrtPaystsCd = succ_obj.payList[0]?.rcrt_paysts_cd || "";
            setPaymentState(
              PaymnetDetailForm(
                succ_obj.prjt_type_cd,
                succ_obj.prjt_sts_cd,
                succ_obj.apprv_sts_cd,
                succ_obj.apply_sts_cd,
                rcrtPaystsCd
              )
            );
            if (
              (rcrtPaystsCd === "ref_req" || rcrtPaystsCd === "ref_res") &&
              succ_obj.paym_at
            ) {
              setChargeInfo(
                ChargeChange(
                  succ_obj.paym_at,
                  succ_obj.paym_amt,
                  succ_obj.prjt_type_cd,
                  succ_obj.prjt_apply_st_at,
                  succ_obj.apply_sts_at
                )
              );
            }
          } else {
            dispatch(ToastChange({ active: true, content: err_msg || "결제 상세를 불러오지 못했습니다." }));
          }
        }).catch(() => {
          dispatch(ToastChange({ active: true, content: "결제 상세를 불러오지 못했습니다. 다시 시도해주세요." }));
        });
    }
    return () => {};
  }, [location.state, dispatch]);
  return data ? (
    <main className="payment-detail-page">
      <div className="wrapper">
        <div className="title">
          <div
            onClick={() => {
              navigate(-1);
            }}
          >
            <div className="img">
              <img src="/assets/common/left-arrow.svg" alt=""></img>
            </div>
          </div>
          <div className="title">결제상세내역</div>
        </div>
        <div className="boxtitle">결제 내용</div>
        <div className="box">
          <div className="left">
            <div
              className="background-img"
              style={{
                backgroundImage: `url(${data.prjt_thumbnail})`,
              }}
            ></div>
          </div>
          <div className="right">
            <div className="top">
              <div className="title">{data.prjt_nm}</div>
            </div>
            <div className="bottom">
              <div className="span">[{data.payList[0].rcrt_nm}]로 신청</div>
              <div className="pay"> {makeComma(data.attd_amt)}원</div>
            </div>
          </div>
        </div>
        <div className="text-title">기본정보</div>
        <div className="text-box">
          <div className="left">
            <div className="text1">아이디</div>
            <div className="text">이메일</div>
            <div className="text">연락처</div>
            <div className="text">활동명</div>
            <div className="text">결제상태</div>
          </div>
          <div className="right">
            <div className="text1">{data.payList[0].login_id}</div>
            <div className="text">{data.usr_email ? data.usr_email : "-"}</div>
            <div className="text">
              {data.rcrt_usr_phone ? data.rcrt_usr_phone : "-"}
            </div>
            <div className="text">
              {data.apply_usr_nm ? data.apply_usr_nm : "-"}
            </div>
            {PaymentState === "wait-state" ||
            PaymentState === "select-wait-state" ? (
              <div className="span">
                결제대기 ({formatDate(data.rcrt_apply_en_at, "-")} 선정예정)
              </div>
            ) : PaymentState === "success-state" ? (
              <div className="span">결제성공</div>
            ) : PaymentState === "refund-ready-state" ? (
              <div className="span-refund-ready">환불요청</div>
            ) : PaymentState === "refund-finish-state" ? (
              <div className="span-refund-success">환불완료</div>
            ) : PaymentState === "reject-state" ? (
              <div className="span-refund-success">선정 거절</div>
            ) : PaymentState === "cancel-state" ? (
              <div className="span-refund-success">신청 취소</div>
            ) : PaymentState === "fail-state" ? (
              <div className="span-fail">
                결제실패 ({data.paym_at ? formatDate(data.paym_at, "-") : "-"})
              </div>
            ) : (
              <div className="span-fail">-</div>
            )}
          </div>
        </div>
        {PaymentState === "fail-state" && (
          <section className="payment-failure" aria-label="결제 실패 원인">
            <strong>결제 실패 원인</strong>
            <p>{formatPaymentFailure(data.paym_fail_reason || data.payList[0]?.paym_fail_reason)}</p>
            {(data.paym_fail_at || data.payList[0]?.paym_fail_at) && (
              <p>실패 시각: {new Date(data.paym_fail_at || data.payList[0].paym_fail_at!).toLocaleString("ko-KR")}</p>
            )}
          </section>
        )}
        <div className="pay-title">결제정보</div>
        <div className="pay-box">
          <div className="top">
            <div className="top">
              <div className="text">금액</div>
              <div className="pay">{makeComma(data.attd_amt)}원</div>
            </div>
            <div className="bottom">
              <div className="text">
                할인 <span>{data.cpon_nm}</span>
              </div>
              <div className="pay">
                {data.cpon_discnt_rate
                  ? makeComma((data.attd_amt * data.cpon_discnt_rate) / 100)
                  : 0}
                원
              </div>
            </div>
          </div>
          <div className="bottom">
            <div className="top">
              <div className="text"> 총금액</div>
              <div className="total-pay">
                {makeComma(
                  data.paym_amt !== undefined
                    ? data.paym_amt
                    : data.cpon_discnt_rate
                    ? data.attd_amt -
                      (data.attd_amt * data.cpon_discnt_rate) / 100
                    : data.attd_amt
                )}
                원
              </div>
            </div>
            {data.prjt_type_cd === "prjt" ? (
              <div className="bottom">바로 결제가 아닌 선정 후 결제 입니다</div>
            ) : undefined}
          </div>
        </div>
        {PaymentState === "refund-ready-state" ||
        PaymentState === "refund-finish-state" ? (
          <div className="day-refund">
            <div className="refund-ready">
              <div className="num1">
                <div className="text">결제일</div>
                <div className="day">
                  {formatDate(data.payList[0].paym_at, "-")}
                </div>
              </div>
              <div className="num1">
                <div className="text">취소일</div>
                <div className="day"> {formatDate(data.apply_sts_at, "-")}</div>
              </div>
              <div className="num1">
                <div className="text">취소일 기준</div>
                <div className="d-day">{chargeInfo.text}</div>
              </div>
              <div className="num1">
                <div className="text">수수료</div>
                <div className="sale">
                  {chargeInfo.type === "charge"
                    ? "20%"
                    : chargeInfo.type === "all"
                    ? "0%"
                    : "환불불가"}
                </div>
              </div>
            </div>
            <div className="num2">
              <div className="text">환불금</div>
              <div className="pay">
                {makeComma(data.paym_amt - chargeInfo.amt)}원
              </div>
            </div>
          </div>
        ) : (
          <div className="day-box">
            <div className="left">
              <div className="text">선정일</div>
              <div className="day">
                {formatDate(data.rcrt_apply_en_at, "-")}
              </div>
            </div>
            <div className="right">
              <div className="text2">결제일</div>
              {PaymentState === "fail-state" ? (
                <div className="d-day-fail">
                  {data.paym_at ? formatDate(data.paym_at, "-") : "-"}
                </div>
              ) : (
                <div className="d-day">
                  {formatDate(
                    data.paym_at ? data.paym_at : data.rcrt_apply_en_at,
                    "-"
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        {PaymentState === "wait-state" || PaymentState === "success-state" ? (
          <>
            <div className="card-title">카드등록정보</div>
            <div className="card-box">
              <div className="type">{data.crd_nm}</div>
              <div className="number">{data.crd_num}</div>
            </div>
          </>
        ) : undefined}
        {PaymentState === "refund-ready-state" &&
        chargeInfo.type !== "no-refund" ? (
          <div className="refund-bluebox" onClick={Refund}>
            환불하기
          </div>
        ) : (
          ""
        )}
      </div>
    </main>
  ) : (
    <></>
  );
}

export default PaymentDetail;

